import { __assign, __awaiter, __generator } from "tslib";
import { STORES_APP_DEF_ID } from '@wix/wixstores-client-core';
import { productOptionsAvailability } from '@wix/ambassador-stores-catalog-v1-product/http';
export var PRODUCT_NOT_MANAGED_DEFAULT_VARIANT_ID = '00000000-0000-0000-0000-000000000000';
/* istanbul ignore next: hard to test */
var mapCustomTextField = function (customTextFieldSelections) {
    if (customTextFieldSelections === undefined || customTextFieldSelections.length === 0) {
        return null;
    }
    var addedMandatoryFields = [];
    return customTextFieldSelections.reduce(function (acc, textField) {
        var customTextFieldKey = textField.key ? textField.key : textField.title;
        var isKeyAlreadyExist = !!acc[customTextFieldKey];
        var isFirstMandatoryTextFieldWithSameKey = function () {
            return textField.isMandatory && addedMandatoryFields.indexOf(customTextFieldKey) === -1;
        };
        if (!isKeyAlreadyExist || isFirstMandatoryTextFieldWithSameKey()) {
            acc[customTextFieldKey] = textField.value;
            textField.isMandatory && addedMandatoryFields.push(customTextFieldKey);
        }
        return acc;
    }, {});
};
var tryResolveVariantId = function (productId, choices, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, selectedVariant, managedProduct, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (Object.keys(choices || {}).length === 0) {
                    return [2 /*return*/, PRODUCT_NOT_MANAGED_DEFAULT_VARIANT_ID];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, context.httpClient.request(productOptionsAvailability({ id: productId, options: choices }))];
            case 2:
                _a = (_b.sent()).data, selectedVariant = _a.selectedVariant, managedProduct = _a.managedProduct;
                return [2 /*return*/, managedProduct ? selectedVariant.variantId : PRODUCT_NOT_MANAGED_DEFAULT_VARIANT_ID];
            case 3:
                e_1 = _b.sent();
                void context.errorHandler.handleError({
                    errorType: 'VARIANT_NOT_FOUND',
                    error: e_1,
                    message: e_1.message,
                });
                return [2 /*return*/, PRODUCT_NOT_MANAGED_DEFAULT_VARIANT_ID];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var mapToLineItem = function (addToCartItem, context) { return __awaiter(void 0, void 0, void 0, function () {
    var productId, quantity, preOrderRequested, _a, options, customTextFields, choices, subscriptionOptionId, variantId, _b, mappedCustomTextFields, lineItemOptions;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                productId = addToCartItem.productId, quantity = addToCartItem.quantity, preOrderRequested = addToCartItem.preOrderRequested, _a = addToCartItem.options, options = _a === void 0 ? {} : _a;
                customTextFields = options.customTextFields, choices = options.choices, subscriptionOptionId = options.subscriptionOptionId;
                if (!((_c = options.variantId) !== null && _c !== void 0)) return [3 /*break*/, 1];
                _b = _c;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, tryResolveVariantId(productId, choices, context)];
            case 2:
                _b = (_d.sent());
                _d.label = 3;
            case 3:
                variantId = _b;
                mappedCustomTextFields = mapCustomTextField(customTextFields);
                lineItemOptions = __assign(__assign(__assign(__assign({ variantId: variantId }, (subscriptionOptionId ? { subscriptionOptionId: subscriptionOptionId } : {})), (preOrderRequested ? { preOrderRequested: preOrderRequested } : {})), (mappedCustomTextFields ? { customTextFields: mappedCustomTextFields } : {})), { options: choices !== null && choices !== void 0 ? choices : {} });
                return [2 /*return*/, {
                        catalogReference: {
                            appId: STORES_APP_DEF_ID,
                            catalogItemId: productId,
                            options: lineItemOptions,
                        },
                        quantity: Number(quantity),
                    }];
        }
    });
}); };
//# sourceMappingURL=mapToLineItem.js.map